<template>
  <div class="text-[9px]" v-if="showDebug">
    <div v-if="displayDetails">
      <span class="text-primary cursor-pointer font-bold uppercase" @click="displayDetails = false">Collapse</span>
      <pre class="leading-3 bg-zinc-100 dark:bg-zinc-800 rounded px-4 py-2"><slot /></pre>
    </div>
    <div v-else class="text-primary cursor-pointer font-bold uppercase inline-block" @click="displayDetails=true">Details ›</div>
  </div>
</template>


<script lang="ts">
  import { defineComponent } from 'vue'

  import { showDebug } from '@/globals/staff'

  export default defineComponent({
    data() {
      return {
        showDebug,
        displayDetails: false,
      }
    },
  })
</script>
